import * as constants from './constants'
import * as ReducerHelper from '@eig-builder/core-utils/helpers/reducer-helper'

const initialState = {
  getSitesByAccountRetrieving: false,
  getCpanelSitesByAccountRetrieving: false,
  getManageServicesByAccountRetrieving: false,
  postMoveServiceToSiteRetrieving: false,
  getContactsBySiteRetrieving: false,
  clearCacheSiteByIdRetrieving: false,
  copyExpressSiteRetrieving: false
}

const reducer = (state = initialState, action) => {
  const listenState =
    ReducerHelper.listenToFetchActions(state, action, constants.GET_SITES_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_PAGINATED_SITES_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_CPANEL_SITES_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_MANAGE_SERVICES_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_MOVE_SERVICE_TO_SITE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_CONTACTS_BY_SITE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.CLEAR_CACHE_SITE_BY_ID) ||
    ReducerHelper.listenToFetchActions(state, action, constants.COPY_EXPRESS_SITE_TO_LATEST) ||
    ReducerHelper.listenToFetchActions(state, action, constants.COPY_EXPRESS_SITE) ||
    state

  switch (action.type) {
    case constants.POST_EXTERNAL_PLATFORM_EMAIL_PENDING:
      return {
        ...state,
        externalEmailRetrieving: true,
        externalEmailError: null,
        externalEmailResponse: null
      }
    case constants.POST_EXTERNAL_PLATFORM_EMAIL_FULFILLED:
      return {
        ...state,
        externalEmailRetrieving: false,
        externalEmailError: null,
        externalEmailResponse: true
      }
    case constants.POST_EXTERNAL_PLATFORM_EMAIL_ERROR:
      return {
        ...state,
        externalEmailRetrieving: false,
        externalEmailError: action.body || true,
        externalEmailResponse: null
      }
    case constants.DELETE_RESTORE_SITE_BY_ID_PENDING:
      return {
        ...state,
        deleteRestoreSiteByIdRetrieving: true,
        deleteRestoreSiteByIdError: null,
        deleteRestoreSiteByIdResponse: null
      }
    case constants.DELETE_RESTORE_SITE_BY_ID_FULFILLED:
      return {
        ...state,
        deleteRestoreSiteByIdRetrieving: false,
        deleteRestoreSiteByIdError: null,
        deleteRestoreSiteByIdResponse: true
      }
    case constants.DELETE_RESTORE_SITE_BY_ID_ERROR:
      return {
        ...state,
        deleteRestoreSiteByIdRetrieving: false,
        deleteRestoreSiteByIdError: action.body || true,
        deleteRestoreSiteByIdResponse: null
      }
  }

  if (listenState) {
    return listenState
  }
}

export default reducer
